import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_WIDTH = 14;
const DEFAULT_HEIGHT = 10;

function IconTick({ class: cssClass, width, color }: Omit<IconProps, "height">) {
    const height = width! * DEFAULT_HEIGHT / DEFAULT_WIDTH;

    return (
        <svg class={cssClass} width={width} height={height} viewBox="0 0 14 10">
            <path
                fill={color}
                fill-rule="evenodd"
                d="M5 10 0 5.192l1.4-1.346L5 7.308 12.6 0 14 1.346z"/>
        </svg>
    );
}

IconTick.defaultProps = {
    width: DEFAULT_WIDTH,
    color: "#C8CF2D"
};

export default IconTick;
